import { Location } from '@angular/common';
import { Component, Inject, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { BookingController } from '@shared/src/controllers/booking/booking.controller';
import { SharedAsideFactory } from '../../../components.api';
import { RouteCardItemDto } from '@shared/src/dtos/route/RouteCardItemDto';
import { HLong } from '@shared/src/datatypes/HLong';

@Component({
	selector: 'shared-active-bookings-item-manage',
	templateUrl: './shared.active.bookings.item.manage.html',
	styleUrls: ['./shared.active.bookings.item.manage.scss']
})
export class SharedActiveBookingsItemManage implements OnInit {

	public useIonic: boolean = false;
	constructor(public activatedRoute: ActivatedRoute,
		public location: Location,
		public router: Router, public bookingController: BookingController,
		@Inject('HomeController') protected homeController: HomeController,
		@Inject("SecurityController") protected securityController: SecurityController,
		@Inject('SharedAsideFactory') public sharedAsideFactory: SharedAsideFactory,
		protected socketController: SocketController) {

		this.socketController.notificationReloadHome$.subscribe(e => {
			this.loadData();
		});

		if (homeController.useIonic)
			this.useIonic = homeController.useIonic();

		//Fem subscribe per detectar només el location.back i location.forward que s'executen  només al anar endevant i enrera en els botons del navegador
		//Nomes ho fem amb aquests dos casos ja que o sinó esta constantment detectant canvis al canviar els parametres de url en el routeTo
		this.location.subscribe(
			((value: PopStateEvent) => {
				console.log(value);
				this.loadParametersLocation();
			}),
			(ex => {
			})
		);
	}
	ngOnInit(): void {
		this.loadParametersLocation();
	}

	public loadParametersLocation() {

		let path = this.location.path();
		if (path == "")
			return;

		let tree = this.router.parseUrl(path);
		let queryParams = tree.queryParams;

		let routeId = queryParams[BookingController.PARAMETERAROUTEIDNAME];
		if (!HLong.isNullOrNullLong(routeId))
			this.routeId = routeId;
	}

	routeTo() {
		if (!this.allLoaded || this.useIonic)
			return;

		let object = { ...this.activatedRoute.snapshot.queryParams };

		if (!HLong.isNullOrNullLong(this.routeId))
			object[BookingController.PARAMETERAROUTEIDNAME] = this.routeId;
		else
			delete object[BookingController.PARAMETERAROUTEIDNAME];

		//Aqui no estem rederigint, només estem actualtzant els queryParams perque es vegi reflectida la URL. 
		//Al no redirigir (que ja es el que volem perquè no es necessàri), no està refrescant la pagina i no entrarà pel ngOnInit()
		this.router.navigate([".", {}], { relativeTo: this.activatedRoute, queryParams: object, queryParamsHandling: '' });
	}

	@Input() public readonly: boolean;

	public searchText: string = "";
	public filterMetadata: any = {};

	public routes: Array<RouteCardItemDto> = [];

	public allLoaded: boolean = false;

	public _bookingId: number;
	@Input()
	public get bookingId(): number {
		return this._bookingId;
	}
	public set bookingId(value: number) {
		if (this._bookingId === value)
			return;
		this._bookingId = value;
		this.loadData();
	}


	public _routeId: number;
	public get routeId(): number {
		return this._routeId;
	}
	public set routeId(value: number) {
		if (this._routeId === value)
			return;
		this._routeId = value;
		this.routeTo();
	}

	@Output() selectRouteChange = new EventEmitter<RouteCardItemDto>();

	public _selectedRoute: RouteCardItemDto;
	public get selectedRoute(): RouteCardItemDto {
		return this._selectedRoute;
	}
	public set selectedRoute(value: RouteCardItemDto) {
		if (this._selectedRoute === value)
			return;
		this._selectedRoute = value;
		this.routeId = value != null ? value.routeId : 0;
		this.selectRouteChange.next(value);
	}

	ngAfterViewChecked(): void {
	}


	loadData() {

		//Si tenim ruta seleccionada, no te sentit fer cerca total
		if (this.routeId > 0)
			return;

		this.bookingController.getRouteItems(this.bookingId).subscribe(data => {

			if (data == null) {
				this.routes = new Array();
				this.allLoaded = true;
				return;
			}

			this.routes = data;
			this.allLoaded = true;

			if (this.routes != null) {

				//comprovem si la seleccionada encara esta
				if (!HLong.isNullOrNullLong(this.routeId)) {
					let i = 0;
					while (i < this.routes.length) {
						if (this.routes[i].routeId == this.routeId) {
							this.selectedRoute = this.routes[i];
							return;
						}
						i++;
					}
				}
			}
			this.selectedRoute = null;
		});
	}

	@Output() reloadBooking = new EventEmitter<boolean>();
	onRouteChanged(item: RouteCardItemDto, reloadbooking: boolean) {
		if (!item)
			return;

		let index = null;
		this.routes.forEach((route, i) => {
			if (route.routeId == item.routeId)
				index = i;
		});

		this.routes[index] = item;
		this.selectedRoute = item;

		if (reloadbooking)
			this.reloadBooking.next(true);
	}

	onDoubleClickItem(route: RouteCardItemDto) {
		if (route == null)
			return;

		//this.sharedAsideFactory.invokeBookingRoute(route).then(value => {
		//	this.loadData();
		//});
	}

	onClickItem(item: RouteCardItemDto) {
		if (item == null) {
			this.selectedRoute = null;
			return;
		}
		this.selectedRoute = item;
	}

	onClickBack(refresh: boolean) {
		this.selectedRoute = null;
		if (refresh || this.routes == null || this.routes.length == 0)
			this.loadData();
	}

	pretty(value) {
		return JSON.stringify(value);
	}
}
